
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.032","d":"M12.271 10.729 8.5 14.5l-3.771-3.771m0-4.458L8.5 2.5l3.771 3.771"}})])
          )
        }
      }
    